export var fixWindowsPath = function (path) { return path.replace(/\\/g, '/'); };
//# sourceMappingURL=fix-windows-path.js.map